import { render, staticRenderFns } from "./GShopTemplate.vue?vue&type=template&id=0803f3f2&"
import script from "./GShopTemplate.vue?vue&type=script&lang=js&"
export * from "./GShopTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports